// extracted by mini-css-extract-plugin
export default {"PrimaryTitleWrapper":"Normative_PrimaryTitleWrapper__Wpw4K","MainWrapper":"Normative_MainWrapper__RKz84","ListWrapper":"Normative_ListWrapper__qj8Vp"};